import api from './api'

class UserService {
  async getUsers(params = {}) {
    const response = await api.get('/users', { params })
    return response.data
  }

  async getUser(id) {
    const response = await api.get(`/users/${id}`)
    return response.data
  }

  async createUser(userData) {
    const response = await api.post('/users', userData)
    return response.data
  }

  async updateUser(id, userData) {
    const response = await api.put(`/users/${id}`, userData)
    return response.data
  }

  async deleteUser(id) {
    const response = await api.delete(`/users/${id}`)
    return response.data
  }

  async getUsersByRole(role) {
    const response = await api.get('/users', { params: { role } })
    return response.data
  }
}

export default new UserService()
